import { STAGE } from '@/utils'
import type { PropsWithChildren } from 'react'

/**
 * Blocks rendering of child components in production stage.
 */
export function HideInProduction({ children }: PropsWithChildren) {
  if (STAGE === 'production') return null

  return children
}

/**
 * Only renders child components in production stage.
 */
export function OnlyInProduction({ children }: PropsWithChildren) {
  if (STAGE !== 'production') return null

  return children
}
